import {
  TRESPONSE_CUTBANK_OUT_ACTIVITY_LOG,
  TRESPONSE_CUTBANK_OUT_TRANSACTION_LOG,
  TRESPONSE_GET_CUTBANK_SUBJECTS,
} from '@monorepo/types';

export type TCutbankOutState = {
  subjects: TRESPONSE_GET_CUTBANK_SUBJECTS;
  transactionLogInfo: TRESPONSE_CUTBANK_OUT_TRANSACTION_LOG | null;
  activityLogInfo: TRESPONSE_CUTBANK_OUT_ACTIVITY_LOG | null;
  isComponentBundleScanEnabled: boolean;
};

export const TCutbankOutActionType = {
  GetSubjectList: 'GET_SUBJECT_LIST_CUTBANK_OUT' as const,
  GetSubjectListSuccess: 'GET_SUBJECT_LIST_CUTBANK_OUT_SUCCESS' as const,
  GetSubjectListFailure: 'GET_SUBJECT_LIST_CUTBANK_OUT_FAILURE' as const,
  GetTransactionLog: 'GET_TRANSACTION_LOG_CUTBANK_OUT' as const,
  GetTransactionLogSuccess: 'GET_TRANSACTION_LOG_CUTBANK_OUT_SUCCESS' as const,
  GetTransactionLogFailure: 'GET_TRANSACTION_LOG_CUTBANK_OUT_FAILURE' as const,
  GetActivityLog: 'GET_ACTIVITY_LOG_CUTBANK_OUT' as const,
  GetActivityLogSuccess: 'GET_ACTIVITY_LOG_CUTBANK_OUT_SUCCESS' as const,
  GetActivityLogFailure: 'GET_ACTIVITY_LOG_CUTBANK_OUT_FAILURE' as const,
  IsComponentBundleScanEnabled: 'IS_COMPONENT_BUNDLE_SCAN_ENABLED_CUTBANK_OUT' as const,
  IsComponentBundleScanEnabledSuccess: 'IS_COMPONENT_BUNDLE_SCAN_ENABLED_CUTBANK_OUT_SUCCESS' as const,
};
